import { render } from "./_PerspectivesTabs.vue?vue&type=template&id=1cec6564&scoped=true"
import script from "./_PerspectivesTabs.vue?vue&type=script&lang=js"
export * from "./_PerspectivesTabs.vue?vue&type=script&lang=js"

import "./_PerspectivesTabs.vue?vue&type=style&index=0&id=1cec6564&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cec6564"]])

export default __exports__